import React from 'react';
import { connect } from 'react-redux';
import { DBTextFieldObjective, ObjectiveFlag } from '_components';
import styles from './Common.module.css'

class ROMShoulderFunctionalER extends React.Component {

    render() {
        return (
            <div className={styles.textfield_row}>
                <ObjectiveFlag className={styles.flag} flagged={this.props.flagged} mopno={this.props.mopno} flagText='ROM - Shoulder Functional ER' />
                <label className={styles.textarea_label}>Shoulder Functional ER</label>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTERAROMR'
                    className={styles.arom_r}
                />
                <span className={styles.arom_c} >
                    <span className={styles.prev_wrapper}>
                        {this.props.prevAromR}
                    </span>
                </span>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTERAROML'
                    className={styles.arom_l}
                />
                <span className={styles.arom_arom_spacer} >
                    <span className={styles.prev_wrapper}>
                        {this.props.prevAromL}
                    </span>
                </span>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTERPROMR'
                    className={styles.prom_r}
                />
                <span className={styles.prom_c} >
                    <span className={styles.prev_wrapper}>
                        {this.props.prevPromR}
                    </span>
                </span>
                <DBTextFieldObjective
                    noteId={this.props.noteId}
                    entity='PTOBJECTIVEROM'
                    entityKeyColumn='RONO'
                    entityKeyValue={this.props.rono}
                    field='ROSHOULDERFUNCTERPROML'
                    className={styles.prom_l}
                />
                <span className={styles.prev_wrapper}>
                    {this.props.prevPromL}
                </span>

            </div>
        );
    }

}

function mapStateToProps(state) {
    let noteId = state.ui.patientTabs[state.ui.patientCenter[state.ui.patients.selectedPtno].selectedTab].noteId;
    let noteType = parseInt(noteId.split("_")[0]);
    let pk = parseInt(noteId.split("_")[1]);
    let rono = parseInt(Object.keys(state.entities.notes.PTOBJECTIVEROM)
        .find(key => (state.entities.notes.PTOBJECTIVEROM[key].ROEVNO === pk && noteType === 1)
            || (state.entities.notes.PTOBJECTIVEROM[key].RONTNO === pk && noteType !== 1)));

    let prevPromR = '';
    let prevPromL = '';
    let prevAromR = '';
    let prevAromL = '';

    if (noteType !== 1 && state.entities.notes.PTOBJECTIVEROMPREV[pk]) {
        prevPromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTERPROMR'];
        prevPromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTERPROML'];
        prevAromR = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTERAROMR'];
        prevAromL = state.entities.notes.PTOBJECTIVEROMPREV[pk]['ROSHOULDERFUNCTERAROML'];
    }

    return {
        noteId: noteId,
        rono: rono,
        flagged: state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTERPROMR ||
            state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTERPROML ||
            state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTERAROMR ||
            state.entities.notes.PTOBJECTIVEROM[rono].ROSHOULDERFUNCTERAROML
            ? true : false,
        prevPromR,
        prevPromL,
        prevAromR,
        prevAromL,

    };
}

const connectedROMShoulderFunctionalER = connect(mapStateToProps)(ROMShoulderFunctionalER);
export { connectedROMShoulderFunctionalER as ROMShoulderFunctionalER };


